export const MAX_VOTE_COUNT_PER_DAY = 5;
export const MAX_VOTE_COUNT_PER_CATEGORY_PER_DAY = 2;
